import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { EditPermissions } from '../../../../../../../shared/models';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { getEditTypes } from '../../../delegatorUtils';
import { required } from '../../../../../../../shared/utils';

export interface RemapValues {
  key: string,
  value: string
}

export interface RemapFrom {
  name: string,
  description: string,
  remapValues: RemapValues[],
  valueToRemap: string,
  yes: string,
  no: string
}


export const NODE_TYPE = 'remap';

export class Remap {

  action: any = {};

  constructor() {
    this.action = {
      'actionType': NODE_TYPE,
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
    const { editMenuTextOnly, editFlows } = getEditTypes(editPermissions);
    const formData: RemapFrom = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): RemapFrom {
    const action = stepData?.action ? stepData?.action : {};
    const actionParams = action?.actionParams ? action?.actionParams : {};
    const result = action?.result ? action?.result : {};

    return {
      name: action.name ? action.name : '',
      description: action.description ? action.description : '',
      valueToRemap: actionParams.valueToRemap ? actionParams.valueToRemap : '',
      remapValues: this.remapValues(actionParams.remapValues),
      yes: result.yes ? result.yes : newStepValue,
      no: result.no ? result.no : newStepValue,
    };
  }

  private static buildForm(formData: RemapFrom, editFlows: boolean) {
    return new UntypedFormGroup({
      name: new UntypedFormControl({
        value: formData.name,
        disabled: !editFlows,
      }, required('Name')),
      description: new UntypedFormControl({
        value: formData.description,
        disabled: !editFlows,
      }, required('Description')),
      remapValues: this.remapValuesForm(formData.remapValues, editFlows),
      valueToRemap: new UntypedFormControl({
        value: formData.valueToRemap,
        disabled: !editFlows,
      }, required('Value to remap')),
      yes: new UntypedFormControl(formData.yes),
      no: new UntypedFormControl(formData.no),
    });
  }

  private static remapValues(values: {}): RemapValues[] {

    if (!values) {
      return [{
        key: '',
        value: '',
      }];
    }

    return Object.keys(values).map(key => ({
      key,
      value: values[key],
    }));
  }


  private static remapValuesForm(values: RemapValues[], editFlows: boolean): UntypedFormArray {

    const remap = new UntypedFormArray([]);

    for (const value of values) {
      remap.push(
        this.remapValueTemplate(value, editFlows),
      );
    }

    return remap;
  }

  public static remapValueTemplate(remapValue: RemapValues, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      key: new UntypedFormControl({
        value: remapValue?.key ? remapValue?.key : '',
        disabled: !editFlows,
      }, required('Key')),
      value: new UntypedFormControl({
        value: remapValue?.value ? remapValue?.value : '',
        disabled: !editFlows,
      }, required('value')),
    });
  }

  get nodeData(): {} {
    return {
      action: this.action,
      'type': 'action',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }

  setNodeData(formData: RemapFrom) {
    const { name, description, yes, no, remapValues, valueToRemap } = formData;

    const remapValue = remapValues
      .map(remap => ({ [remap.key]: remap.value }))
      .reduce((previousValue, currentValue) => ({ ...previousValue, ...currentValue }), {});

    const actionParams = {
      remapValues: remapValue,
      valueToRemap,
    };

    const result = {
      yes,
      no,
    };

    this.action = {
      ...this.action,
      name,
      description,
      actionParams,
      result,
    };
  }
}
